import { axios } from '@/utils/request'

const api = {
  getGoods: '/5dddda3a490be',
  createAlipayBuyNbOrder: '/5ddc7e3dafe16',
  transfer: '/5dde39218460e',
  getList: '/5dde295c5b0a2'
}

export default {
  // 获取收支明细
  getList: parameter => {
    const params = Object.assign(parameter, {
      page: parameter.pageNo || 1,
      size: parameter.pageSize || 20
    })
    return axios({
      url: api.getList,
      method: 'get',
      params: params
    }).then(res => {
      return {
        data: res.data.list || [],
        pageNo: parameter.pageNo,
        pageSize: parameter.pageSize,
        totalCount: res.data.count
      }
    })
  },
  // 展示NB充值商品
  getGoods: parameter => {
    const params = parameter
    return axios({
      url: api.getGoods,
      method: 'get',
      params: params
    })
  },
  // 创建支付宝购买NB订单
  createAlipayBuyNbOrder: ({ product_type, product_number, main_id }) => {
    return new Promise((resolve, reject) => {
      const link = `https://cloudmanage.nianchu.net/api${api.createAlipayBuyNbOrder}?product_type=${product_type}&product_number=${product_number}&main_id=${main_id}`
      resolve(link)
    })
  },
  // 转账
  transfer: parameter => {
    const params = parameter
    return axios({
      url: api.transfer,
      method: 'post',
      data: params
    })
  }
}
